import NextLink from 'next/link';
import type { LinkProps } from 'next/link';

export interface ExtendedLinkProps extends React.PropsWithChildren<LinkProps> {
  href: string | LinkProps['href'];
  className?: string;
  'data-testid'?: string | undefined;
  onClick?: React.MouseEventHandler;
  target?: '_self' | '_blank' | '_parent' | '_top';
  rel?: 'nofollow' | 'noreferrer' | 'noopener' | string;
  style?: React.CSSProperties;
}
export const Link = ({ href = {}, children, className, target = '_self', onClick, rel, style, ...props }: ExtendedLinkProps): JSX.Element => {
  const urlString = getURLString(href);

  return (
    <NextLink passHref href={href} {...props}>
      <a style={style} href={urlString} rel={rel} target={target} onClick={onClick} className={className} data-testid={props['data-testid'] || ''}>
        {children}
      </a>
    </NextLink>
  );
};

function getURLString(href: unknown): string | undefined {
  if (typeof href === 'string') {
    return href;
  }

  if (href && typeof href === 'object' && 'asPath' in href) {
    return String(href.asPath);
  }

  return undefined;
}
